<template>
  <div style="margin-top: 20px">
    <Table
      :data="tableData"
      :columns="columns"
      stripe
      ref="table"
      :height="370"
      show-summary
      no-data-text="<div class='table-no-data'></div>"
    >
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="pageSize"
          :page-size-opts="[50, 100, 200, 500, 1000]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var store = [];
export default {
  data() {
    return {
      openTable: false,
      columns: [
        {
          title: "月份",
          key: "date",
        },
        {
          title: "总费用",
          key: "totalCost",
        },
        {
          title: "平均费用",
          key: "avgCost",
        },
        {
          title: "保养费用",
          key: "careCost",
        },

        {
          title: "保险费用",
          key: "insuCost",
        },
        {
          title: "违章费用",
          key: "peccCost",
        },
        {
          title: "加油费用",
          key: "refuCost",
        },
        {
          title: "维修费用",
          key: "repaCost",
        },
        {
          title: "其他费用",
          key: "payCost",
        },
      ],
      tableData: [],
      pageNumber: 1,
      pageSize: 500,
      total: 0,
    };
  },
  methods: {
    reachData(data) {
      store = data;
      this.total = data.length;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    open() {
      this.openTable = true;
    },
    //页码切换时触发
    changePage(x) {
      this.pageNumber = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.pageSize = x;
      this.tableData = this.utils.page(this.pageNumber, this.pageSize, store);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/dataAnalyse/feiyongqushi/tableList.vue